import { render } from "./RollCard.vue?vue&type=template&id=6f106e38&scoped=true"
import script from "./RollCard.vue?vue&type=script&lang=js"
export * from "./RollCard.vue?vue&type=script&lang=js"

import "./RollCard.vue?vue&type=style&index=0&id=6f106e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f106e38"]])

export default __exports__